import React, { FC } from 'react'

import { ReceiptItem } from '../ReceiptItem/ReceiptItem'

import { IRegistrationTicketInterface } from '../../../../models/registration-tickets/registrationTicket.interface'
import { ITotalPrices } from '../../../../helpers/payment'

interface ReceiptTicketsListProps {
  tickets?: { items: IRegistrationTicketInterface[]; totalPrice: ITotalPrices }
  currency: string
}

export const ReceiptTicketsList: FC<ReceiptTicketsListProps> = ({ tickets, currency }) => {
  return (
    <div className="py-5">
      <h3 className="text-base font-semibold mb-3 break-inside-avoid">Tickets</h3>
      <div className="space-y-2">
        {tickets?.items?.map((item) => (
          <ReceiptItem
            key={item.id}
            title={item.ticketTitle || 'N/A'}
            selectedCount={item.selectedUnitsCount || 0}
            price={item.ticketPrice * item.selectedUnitsCount || 0}
            originalPrice={(item.originalTicketPrice || 0) * item.selectedUnitsCount || 0}
            paidDate={item.paidDate || null}
            cardNo={item.cardNo}
            paymentType={item.paymentType}
            paymentStatus={item.paymentStatus}
            amountRefunded={item.amountRefunded}
            isRefunded={item.refundAmountAdded || false}
            refundedDate={item.refundedDate || null}
            isScratched={item.isScratched || false}
            scratchedDate={item.scratchedDate || null}
            ownerId={item.ownerId}
            ownerName={item.ownerName || null}
            recipientId={item.recipientId}
            recipientName={item.recipientName}
            currency={currency}
          />
        ))}
      </div>
    </div>
  )
}
